export const endpoints = {
    account: {
        checkEmailExists: 'api/v1/account/auth/check-email-exists',
        editUserData: 'api/v1/account/user',
        updateLanguage: 'api/v1/account/user/language',
        login: 'api/v1/account/auth/login',
        getFullUserData: 'api/v1/account/user',
        createInstance: 'api/v1/instance',
        listInstances: 'api/v1/instance/list',
        checkInstanceNameIfExists: 'api/v1/instance/instance-name-validator',
        editInstance: 'api/v1/instance',
        deleteInstanceById: 'api/v1/instance/:id',
        createServer: 'api/v1/server',
        editServer: 'api/v1/server',
        deleteServerById: 'api/v1/server/:id',
        getServerByName: 'api/v1/server/name/:serverName',
        sendLoginUrl: 'api/v1/account/auth/send-login-url',
        crypt: 'api/v1/account/auth/crypt',
        getInstanceByOrganizationId: 'api/v1/account/instance/:organizationId',
        moveInstanceFilesToAnother: 'api/v1/instance/move-instance-files-to-another',
        changeInstancePlan: 'api/v1/instance/change-instance-plan',
        toggleApiAccess: 'api/v1/instance/toggle-api-access',
        addCredits: 'api/v1/instance/add-credits',
        getInstanceCredits: 'api/v1/instance/:organizationId/credits',
        getInstanceUsage: 'api/v1/instance/:organizationId/usage',
    },
    stripe: {
        getUserStripeCard: 'api/v1/stripe/card',
        submitNewStripeCard: 'api/v1/stripe/card',
        subscriptionCheckout: 'api/v1/stripe/subscription-checkout',
        customerPortal: 'api/v1/stripe/customer-portal',
        getInstanceSubscription: 'api/v1/stripe/subscription/:instanceId',
        updateInstanceSubscription: 'api/v1/stripe/subscription/update',
        cancelInstanceSubscription: 'api/v1/stripe/subscription/:instanceId',
    },
    credits: {
        getCreditsPacks: 'api/v1/credits/packs',
        getUserCredits: 'api/v1/credits/balance',
        createCheckout: 'api/v1/credits/checkout',
        spendingAnalytics: 'api/v1/credits/spending-analytics',
        autoRecharge: 'api/v1/credits/auto-recharge',
    },
    external: {
        trackEvent: 'api/v1/external/track-event',
    },
    assistantChat: {
        getAll: 'api/v1/assistant-chat/all',
        getById: 'api/v1/assistant-chat/:chatId',
        sendMessage: 'api/v1/assistant-chat/:chatId/message',
        markSeen: 'api/v1/assistant-chat/:chatId/mark-seen',
        markResponded: 'api/v1/assistant-chat/:chatId/mark-responded',
        /** Pin a chat to the Favourites tab, or unpin it. */
        favourite: 'api/v1/assistant-chat/:chatId/favourite',
        editMessage: 'api/v1/assistant-chat/:chatId/message',
        deleteMessage: 'api/v1/assistant-chat/:chatId/message',
        organizationsWithoutChats: 'api/v1/assistant-chat/organizations-without-chats',
        createChat: 'api/v1/assistant-chat/create',
        getSuggestion: 'api/v1/assistant-chat/:chatId/suggestion',
        /** Reject a draft for good — the server stops returning it. */
        discardSuggestion: 'api/v1/assistant-chat/:chatId/suggestion/discard',
        translateMessage: 'api/v1/assistant-chat/:chatId/message/translate',
        polish: 'api/v1/assistant-chat/polish',
        uploadFile: 'api/v1/assistant-chat/upload-file',
        getUserCredits: 'api/v1/assistant-chat/:chatId/user-credits',
        giveCredits: 'api/v1/assistant-chat/:chatId/give-credits',
        removeCredits: 'api/v1/assistant-chat/:chatId/remove-credits',
    },
    referrals: {
        getInstances: 'api/v1/referrals/instances',
        getStatistics: 'api/v1/referrals/statistics',
    },
    affiliate: {
        getDashboard: 'api/v1/affiliate/dashboard',
        validateCode: 'api/v1/affiliate/validate/:code',
        getRewardsInfo: 'api/v1/affiliate/rewards-info',
        updateNotifications: 'api/v1/affiliate/notifications',
    },
    apiKeys: {
        list: 'api/v1/api-keys',
        create: 'api/v1/api-keys',
        decrypt: 'api/v1/api-keys/:id/decrypt',
        updateAllowedProjects: 'api/v1/api-keys/:id/allowed-projects',
        delete: 'api/v1/api-keys/:id',
    },
    vcaas: {
        getCreditCosts: 'api/v1/vcaas/credit-costs',
        getWebhooks: 'api/v1/vcaas/webhooks',
        createWebhook: 'api/v1/vcaas/webhooks',
        deleteWebhook: 'api/v1/vcaas/webhooks/:id',
    },
    // CEO-only dashboard. Backend gates these on JWT + the speedparadigm account.
    ceoDashboard: {
        overview: 'api/v1/ceo-dashboard/overview',
        /** ⭐ The growth console (new /ceo/dashboard) and its processed-JSON export. */
        growth: 'api/v1/ceo-dashboard/growth',
        growthExport: 'api/v1/ceo-dashboard/growth/export',
        filterOptions: 'api/v1/ceo-dashboard/filter-options',
        recentPurchases: 'api/v1/ceo-dashboard/recent-purchases',
        users: 'api/v1/ceo-dashboard/users',
        userDetail: 'api/v1/ceo-dashboard/users/:userId',
        projects: 'api/v1/ceo-dashboard/projects',
        acquisitionReport: 'api/v1/ceo-dashboard/acquisition-report',
        giveCredits: 'api/v1/ceo-dashboard/users/:userId/give-credits',
        removeCredits: 'api/v1/ceo-dashboard/users/:userId/remove-credits',
        /**
         * ⭐ Moves a NEW-PLATFORM account onto another plan without invoicing it.
         * Capped at 10 changes per UTC day server-side; refuses any account with a
         * live Stripe subscription (Stripe would revert it on the next invoice).
         */
        setUserPlan: 'api/v1/ceo-dashboard/users/:userId/plan',
        setUserProjectLimits: 'api/v1/ceo-dashboard/users/:userId/project-limits',
        /** How much of today's 10-change budget is left, plus the grantable plans. */
        planChangeUsage: 'api/v1/ceo-dashboard/plan-changes/usage',
        /**
         * ⭐⭐ Mints a login link into ONE customer project. POST, password-gated on top
         * of the CEO session — the lists deliberately never carry `defaultUser`.
         */
        projectOpenUrl: 'api/v1/ceo-dashboard/projects/:organizationId/open-url',
        /**
         * ⚠️ DELETES A CUSTOMER'S PROJECT: its sites, sandbox VM and instance row. POST
         * with `{ password, confirm }` — the same access password as `projectOpenUrl`,
         * plus the project id typed back. Safe to call again after a partial failure.
         */
        projectDelete: 'api/v1/ceo-dashboard/projects/:organizationId/delete',
        /** ⚠️ DELETES A USER ACCOUNT + ALL ITS PROJECTS. POST `{ password, confirm }` (confirm = the user's email). */
        userDelete: 'api/v1/ceo-dashboard/users/:userId/delete',
        /** ⚠️ BULK CLEANUP OF FREE ACCOUNTS (page /ceo/free-cleanup): list → dry run (token, 10 min) → execute (password + typed phrase) → poll the job. */
        bulkCleanupCandidates: 'api/v1/ceo-dashboard/bulk-cleanup/candidates',
        bulkCleanupDryRun: 'api/v1/ceo-dashboard/bulk-cleanup/dry-run',
        bulkCleanupExecute: 'api/v1/ceo-dashboard/bulk-cleanup/execute',
        bulkCleanupJob: 'api/v1/ceo-dashboard/bulk-cleanup/jobs/:jobId',
        platformLoginUrl: 'api/v1/ceo-dashboard/users/:userId/platform-login-url',
        /**
         * ⭐ SHAREABLE TEMPLATE LINKS — the registry behind
         * `platform.totalum.app/register?template=<alias>` (page: /ceo/templates).
         *
         * ⚠️ EVERY ROW CARRIES A BEARER CREDENTIAL. The export code lets anyone import
         * the source project, which is exactly why the PUBLIC link carries the alias
         * instead. The backend answers these `no-store`; the page masks the code behind
         * a reveal toggle.
         */
        importTemplates: 'api/v1/ceo-dashboard/import-templates',
        importTemplate: 'api/v1/ceo-dashboard/import-templates/:templateId',
        importTemplateClaims: 'api/v1/ceo-dashboard/import-templates/:templateId/imports',
        /**
         * ⚠️⚠️ RETURNS THE `ceo-admin-secret` ITSELF, so the page can show a working
         * `curl`. POST on purpose — a GET would put a live secret in the URL, the
         * history and every proxy log on the way.
         */
        importTemplateApiCredentials: 'api/v1/ceo-dashboard/import-templates/api-credentials',
        /** Credit packs CRUD (page: /ceo/credits-packs). */
        creditsPacks: 'api/v1/ceo-dashboard/credits-packs',
        creditsPack: 'api/v1/ceo-dashboard/credits-packs/:packId',
        /** The signup email-domain blocklist (page: /ceo/block). */
        blockedEmailDomains: 'api/v1/ceo-dashboard/blocked-email-domains',
        blockedEmailDomain: 'api/v1/ceo-dashboard/blocked-email-domains/:domain',
    /** The signup IP blocklist — the other half of the same page. `:ip` is URL-encoded (a CIDR contains `/`). */
    blockedIps: 'api/v1/ceo-dashboard/blocked-ips',
    blockedIp: 'api/v1/ceo-dashboard/blocked-ips/:ip',
    signupRefusals: 'api/v1/ceo-dashboard/signup-refusals',
    },
    /**
     * ⭐ CEO EMAIL CAMPAIGNS + QUICK CONTACT (page: /ceo/emails, and the "Contact" button
     * in the customer panel). CEO-only on the backend, like `ceoDashboard`.
     */
    ceoEmails: {
        meta: 'api/v1/ceo-emails/meta',
        audiencePreview: 'api/v1/ceo-emails/audience/preview',
        audienceAi: 'api/v1/ceo-emails/audience/ai',
        searchUsers: 'api/v1/ceo-emails/users/search',
        warmup: 'api/v1/ceo-emails/warmup',
        preview: 'api/v1/ceo-emails/preview',
        test: 'api/v1/ceo-emails/test',
        quickTemplates: 'api/v1/ceo-emails/quick-templates',
        quickTemplate: 'api/v1/ceo-emails/quick-templates/:templateId',
        contactUser: 'api/v1/ceo-emails/users/:userId/contact',
        contactHistory: 'api/v1/ceo-emails/users/:userId/contacts',
        campaigns: 'api/v1/ceo-emails/campaigns',
        campaign: 'api/v1/ceo-emails/campaigns/:campaignId',
        campaignAction: 'api/v1/ceo-emails/campaigns/:campaignId/:action',
        globalDiscard: 'api/v1/ceo-emails/global-discard',
        exclusions: 'api/v1/ceo-emails/exclusions',
        exclusionsRemove: 'api/v1/ceo-emails/exclusions/remove',
        polish: 'api/v1/ceo-emails/polish',
        images: 'api/v1/ceo-emails/images',
    },
    // Claude OAuth worker fleet (/ceo/oauths). Admin-only, same CEO gate as above.
    // The backend proxies every one of these to the firefox-automation root server —
    // that host and its shared secret are never reachable from the browser.
    oauthServers: {
        workers: 'api/v1/oauth-servers/workers',
        summary: 'api/v1/oauth-servers/summary',
        activity: 'api/v1/oauth-servers/activity',
        creditHistory: 'api/v1/oauth-servers/credit-history',
        queueStatus: 'api/v1/oauth-servers/queue-status',
        loginStatus: 'api/v1/oauth-servers/login-status',
        selfHealStatus: 'api/v1/oauth-servers/self-heal-status',
        provisions: 'api/v1/oauth-servers/provisions',
        screenshot: 'api/v1/oauth-servers/screenshot/:name',
        checkEmail: 'api/v1/oauth-servers/check-email',
        createWorker: 'api/v1/oauth-servers/workers',
        resumeProvision: 'api/v1/oauth-servers/provisions/:jobId/resume',
        logout: 'api/v1/oauth-servers/logout',
        startLogin: 'api/v1/oauth-servers/login/start',
        submitLoginCode: 'api/v1/oauth-servers/login/submit-code',
        workerState: 'api/v1/oauth-servers/workers/:workerId/state',
        deleteWorkerPreview: 'api/v1/oauth-servers/workers/:workerId/delete-preview',
        deleteWorker: 'api/v1/oauth-servers/workers/:workerId/delete',
        deployAll: 'api/v1/oauth-servers/deploy-all',
    }

}